import {useEffect} from 'react';
import {Col, Row} from 'antd';
import {useIntl} from 'react-intl';
import {useFormikContext} from 'formik';
import {Input} from 'formik-antd';
import FormItem from '../../../../../../shared/components/form-item';
import MainUtils from '../../../../../../shared/utils/main';
import {
  getLocaleValue,
  handleChangeLocales,
} from 'src/shared/functions/change-locales';

interface IBannerLanguageProps {
  code?: string;
  index?: number;
}
const BannerLanguage = (props: IBannerLanguageProps) => {
  const {code} = props;

  const {messages} = useIntl();

  const {setFieldValue, values} = useFormikContext<any>();

  return (
    <>
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <FormItem
            name='name'
            label={messages['common.name'].toString()}
            titleTooltip={messages[
              'tooltip.promotions.banners.name'
            ].toString()}
            isTooltip
            fieldCommponent={
              <Input
                name='name'
                value={getLocaleValue(values?.locales, code, 'name')}
                onChange={(value) =>
                  handleChangeLocales(
                    values?.locales,
                    setFieldValue,
                    `locales`,
                    code,
                    'name',
                    value.target.value,
                  )
                }
              />
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default BannerLanguage;
